/**
 * Строка «Настроек» и профиля (03.11.2026).
 *
 * Значок — стеклом, как у частей плана и вариантов «Как убрать нехватку»;
 * название, одна серая строка под ним, справа — значение или стрелка.
 * Прежде в «Настройках» стояли вперемешку строки без значков, строки со
 * значком без подложки и серые кнопки во всю ширину — владелец: «стили
 * хромают».
 */
import type { CSSProperties, ReactNode } from 'react';
import { Icon } from './icon.js';

export function SetRow({ icon, tone, title, sub, right, danger = false, onClick, href }: {
  icon: string;
  /** Цвет значка; по умолчанию — тёмно-серый. */
  tone?: string;
  title: ReactNode;
  sub?: ReactNode;
  /** Справа вместо стрелки: сумма, «всегда», переключатель. */
  right?: ReactNode;
  /** Необратимое: название красным. */
  danger?: boolean;
  onClick?: () => void;
  href?: string;
}) {
  const body = (
    <>
      <span className="picon" style={{ '--c': danger ? 'var(--bad)' : tone ?? 'var(--ink-2)' } as CSSProperties}>
        <Icon name={icon} size={16} /></span>
      <div className="nm"><b className={danger ? 'bad' : undefined}>{title}</b>{sub && <span>{sub}</span>}</div>
      {right ?? (onClick || href ? <Icon name="chevron-right" size={13} className="ch" /> : null)}
    </>
  );
  if (href) return <a className="li w setrow" href={href}>{body}</a>;
  if (onClick) return <button type="button" className="li w setrow" onClick={onClick}>{body}</button>;
  return <div className="li setrow">{body}</div>;
}
